import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import "./ClientReport.css";
import MediaQuery from "react-responsive";
import Slider from "react-slick";

import MainJobTitle from "../../../components/Client/MainJobTitle/MainJobTitle";
import * as actions from "../../../store/actions/index";
import axios from "../../../services/axios-service";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import ConsoleLog from "../../../hoc/ConsoleLog/ConsoleLog";
import TotalCount from "../../../components/UI/ReportsComponents/TotalCount/TotalCount";
import CircleProgressBar from "../../../components/UI/ReportsComponents/CircleProgressBar/CircleProgressBar";
import MultiVerticalProgressBar from "../../../components/UI/ReportsComponents/MultiVerticalProgressBar/MultiVerticalProgressBar";
import FormGrid from "../../../components/UI/FormGrid/FormGrid";

/**
 * @desc All Reports section under client Login
 * @version
 * @author Amrutha,Jamshith
 */
const initialJobDetails = {
  completed_count: 0,
  progressed_count: 0,
  regretted_count: 0,
  sent_to_client: 0,
  unsorted_count: 0,
  viewed_count: 0,
  progressPercent: 0,
  regretPercent: 0,
  unsortedPercent: 0
};

class ClientReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jobDetails: { ...initialJobDetails },
      topProgressedJobs: []
    };
  }

  componentDidMount() {
    this.getJobReport(this.props.jobTitleId);
    this.getTopProgressedJobs(this.props.clientDetails.user_company_id);
  }

  handleJobSelected = jobId => {
    const jobList = [...this.props.jobs];
    if (jobList.length > 0 && jobList.find(job => job.job_id == jobId)) {
      const jobTitle = jobList.find(job => job.job_id == jobId).job_name;
      const jobBHID = jobList.find(job => job.job_id == jobId).job_bh_id;
      if (parseInt(jobId) !== parseInt(this.props.jobTitleId)) {
        this.props.onSetJobTitles(jobId, jobTitle, jobBHID);
        this.getJobReport(jobId);
        let newJobDetails = { ...this.state.jobDetails };
        newJobDetails.progressPercent = 0;
        newJobDetails.regretPercent = 0;
        newJobDetails.unsortedPercent = 0;
        this.setState({ jobDetails: { ...newJobDetails } });
      }
    }
  };
  getJobReport = jobId => {
    axios
      .get("/galaxy/report/client?jobId=" + jobId)
      .then(response => {
        let newJobDetails = { ...response.data };
        newJobDetails.progressPercent = newJobDetails.progressed_count
          ? Math.floor(
              (newJobDetails.progressed_count / newJobDetails.sent_to_client) *
                100
            )
          : 0;
        newJobDetails.regretPercent = newJobDetails.regretted_count
          ? Math.floor(
              (newJobDetails.regretted_count / newJobDetails.sent_to_client) *
                100
            )
          : 0;
        newJobDetails.unsortedPercent = newJobDetails.unsorted_count
          ? Math.floor(
              (newJobDetails.unsorted_count / newJobDetails.sent_to_client) *
                100
            )
          : 0;
        this.setState({ jobDetails: newJobDetails });
      })
      .catch(error => {
        ConsoleLog("error", error);
      });
  };

  getTopProgressedJobs = companyId => {
    axios
      .get("/galaxy/report/client?companyId=" + companyId)
      .then(response => {
        let topProgressedJobs = [...response.data];
        this.setState({ topProgressedJobs });
      })
      .catch(error => {
        ConsoleLog("error", error);
      });
  };

  render() {
    const slickSettings = {
      dots: false,
      infinite: false,
      centerMode: true,
      centerPadding: "10px",
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };
    return (
      <div className="client-report">
        <MainJobTitle
          titleClass={"pool-title "}
          className={"main-job-head report"}
          currentPage="report"
          handleJobSelected={this.handleJobSelected}
        />
        {/* Client reports Total count first main row starts */}
        {/* Client reports Total count first main row Mobile view starts */}
        <MediaQuery query="(max-device-width: 767px)">
          <div className="canditate-total">
            <div className="row">
              <Slider {...slickSettings}>
                <div
                  className={
                    this.state.jobDetails.sent_to_client < 100
                      ? "col-md-4 hide-count-digit"
                      : "col-md-4"
                  }
                >
                  <TotalCount
                    title={"Total Candidates Received"}
                    bgcolor={"#24ccb8"}
                    className={"sent-client"}
                    id={"totalSent"}
                    count={
                      this.state.jobDetails.sent_to_client
                        ? this.state.jobDetails.sent_to_client < 100
                          ? parseInt(this.state.jobDetails.sent_to_client) + 100
                          : this.state.jobDetails.sent_to_client
                        : 100
                    }
                    isCount={true}
                  />
                </div>
                <div
                  className={
                    this.state.jobDetails.viewed_count < 100
                      ? "col-md-4 hide-count-digit"
                      : "col-md-4"
                  }
                >
                  <TotalCount
                    title={"Total Candidates Viewed"}
                    bgcolor={"#ffc400"}
                    className={"card-item viewed-client"}
                    id={"totalViewed"}
                    count={
                      this.state.jobDetails.viewed_count
                        ? this.state.jobDetails.viewed_count < 100
                          ? parseInt(this.state.jobDetails.viewed_count) + 100
                          : this.state.jobDetails.viewed_count
                        : 100
                    }
                    isCount={true}
                  />
                </div>
                <div
                  className={
                    this.state.jobDetails.completed_count < 100
                      ? "col-md-4 hide-count-digit"
                      : "col-md-4"
                  }
                >
                  <TotalCount
                    title={"Total Candidates Completed"}
                    bgcolor={"#3995b4"}
                    className={"card-item completed-client"}
                    id={"totalCompleted"}
                    count={
                      this.state.jobDetails.completed_count
                        ? this.state.jobDetails.completed_count < 100
                          ? parseInt(this.state.jobDetails.completed_count) +
                            100
                          : this.state.jobDetails.completed_count
                        : 100
                    }
                    isCount={true}
                  />
                </div>
              </Slider>
            </div>
          </div>
        </MediaQuery>
        {/* Client reports Total count first main row Mobile view ends */}

        {/* Client reports Total count first main row Desktop view starts */}
        <MediaQuery query="(min-device-width: 768px)">
          <div className="canditate-total">
            <div className="row">
              <div
                className={
                  this.state.jobDetails.sent_to_client < 100
                    ? "col-md-4 hide-count-digit"
                    : "col-md-4"
                }
              >
                <TotalCount
                  title={"Total Candidates Received"}
                  bgcolor={"#24ccb8"}
                  className={"sent-client"}
                  id={"totalSent"}
                  count={
                    this.state.jobDetails.sent_to_client
                      ? this.state.jobDetails.sent_to_client < 100
                        ? parseInt(this.state.jobDetails.sent_to_client) + 100
                        : this.state.jobDetails.sent_to_client
                      : 100
                  }
                  isCount={true}
                />
              </div>
              <div
                className={
                  this.state.jobDetails.viewed_count < 100
                    ? "col-md-4 hide-count-digit"
                    : "col-md-4"
                }
              >
                <TotalCount
                  title={"Total Candidates Viewed"}
                  bgcolor={"#ffc400"}
                  className={"card-item viewed-client"}
                  id={"totalViewed"}
                  count={
                    this.state.jobDetails.viewed_count
                      ? this.state.jobDetails.viewed_count < 100
                        ? parseInt(this.state.jobDetails.viewed_count) + 100
                        : this.state.jobDetails.viewed_count
                      : 100
                  }
                  isCount={true}
                />
              </div>
              <div
                className={
                  this.state.jobDetails.completed_count < 100
                    ? "col-md-4 hide-count-digit"
                    : "col-md-4"
                }
              >
                <TotalCount
                  title={"Total Candidates Completed"}
                  bgcolor={"#3995b4"}
                  className={"card-item completed-client"}
                  id={"totalCompleted"}
                  count={
                    this.state.jobDetails.completed_count
                      ? this.state.jobDetails.completed_count < 100
                        ? parseInt(this.state.jobDetails.completed_count) + 100
                        : this.state.jobDetails.completed_count
                      : 100
                  }
                  isCount={true}
                />
              </div>
            </div>
          </div>
          {/* Client reports Total count first main row Desktop view ends */}
        </MediaQuery>
        {/* Recruiter reports circle progresbar second main row  starts */}
        {/* Recruiter reports circle progreebar second main row Mobile view starts */}
        <MediaQuery query="(max-device-width: 767px)">
          <div class="canditate-progress">
            <div class="row">
              <Slider {...slickSettings}>
                <div class="col-md-4">
                  <CircleProgressBar
                    className={"prog-candidates"}
                    title={"Progressed Candidates"}
                    strokeDashArray={this.state.jobDetails.progressPercent}
                    stroke={"#caeea4"}
                    strokeColor={"url(#green)"}
                    linearGradientColor={"green"}
                    stopColorStart={"#9ec279"}
                    stopColorEnd={"#caeea4"}
                    processedCount={
                      this.state.jobDetails.progressed_count
                        ? parseInt(this.state.jobDetails.progressed_count) < 100
                          ? parseInt(this.state.jobDetails.progressed_count) +
                            100
                          : parseInt(this.state.jobDetails.progressed_count)
                        : 100
                    }
                    totalCount={
                      parseInt(this.state.jobDetails.sent_to_client) < 100
                        ? parseInt(this.state.jobDetails.sent_to_client) + 100
                        : parseInt(this.state.jobDetails.sent_to_client)
                    }
                  />
                </div>
                <div class="col-md-4">
                  <CircleProgressBar
                    className={"reg-candidates"}
                    title={"Regretted Candidates"}
                    strokeDashArray={this.state.jobDetails.regretPercent}
                    stroke={"#f9868c"}
                    strokeColor={"url(#red)"}
                    linearGradientColor={"red"}
                    stopColorStart={"#c63941"}
                    stopColorEnd={"#f9868c"}
                    processedCount={
                      this.state.jobDetails.regretted_count
                        ? parseInt(this.state.jobDetails.regretted_count) < 100
                          ? parseInt(this.state.jobDetails.regretted_count) +
                            100
                          : parseInt(this.state.jobDetails.regretted_count)
                        : 100
                    }
                    totalCount={
                      parseInt(this.state.jobDetails.sent_to_client) < 100
                        ? parseInt(this.state.jobDetails.sent_to_client) + 100
                        : parseInt(this.state.jobDetails.sent_to_client)
                    }
                  />
                </div>
                <div class="col-md-4">
                  <CircleProgressBar
                    className={"unsort-candidates"}
                    title={"Unsorted Candidates"}
                    strokeDashArray={this.state.jobDetails.unsortedPercent}
                    stroke={"#609eda"}
                    strokeColor={"url(#blue)"}
                    linearGradientColor={"blue"}
                    stopColorStart={"#14385b"}
                    stopColorEnd={"#609eda"}
                    processedCount={
                      this.state.jobDetails.unsorted_count
                        ? parseInt(this.state.jobDetails.unsorted_count) < 100
                          ? parseInt(this.state.jobDetails.unsorted_count) + 100
                          : parseInt(this.state.jobDetails.unsorted_count)
                        : 100
                    }
                    totalCount={
                      parseInt(this.state.jobDetails.sent_to_client) < 100
                        ? parseInt(this.state.jobDetails.sent_to_client) + 100
                        : parseInt(this.state.jobDetails.sent_to_client)
                    }
                  />
                </div>
              </Slider>
            </div>
          </div>
        </MediaQuery>
        {/* Recruiter reports circle progreebar second main row Mobile view ends */}

        {/* Recruiter reports circle progreebar second main row Desktop view starts */}
        <MediaQuery query="(min-device-width: 768px)">
          <div class="canditate-progress">
            <div class="row">
              <div class="col-md-4">
                <CircleProgressBar
                  className={"prog-candidates"}
                  title={"Progressed Candidates"}
                  strokeDashArray={this.state.jobDetails.progressPercent}
                  stroke={"#caeea4"}
                  strokeColor={"url(#green)"}
                  linearGradientColor={"green"}
                  stopColorStart={"#9ec279"}
                  stopColorEnd={"#caeea4"}
                  processedCount={
                    this.state.jobDetails.progressed_count
                      ? parseInt(this.state.jobDetails.progressed_count) < 100
                        ? parseInt(this.state.jobDetails.progressed_count) + 100
                        : parseInt(this.state.jobDetails.progressed_count)
                      : 100
                  }
                  totalCount={
                    parseInt(this.state.jobDetails.sent_to_client) < 100
                      ? parseInt(this.state.jobDetails.sent_to_client) + 100
                      : parseInt(this.state.jobDetails.sent_to_client)
                  }
                />
              </div>
              <div class="col-md-4">
                <CircleProgressBar
                  className={"reg-candidates"}
                  title={"Regretted Candidates"}
                  strokeDashArray={this.state.jobDetails.regretPercent}
                  stroke={"#f9868c"}
                  strokeColor={"url(#red)"}
                  linearGradientColor={"red"}
                  stopColorStart={"#c63941"}
                  stopColorEnd={"#f9868c"}
                  processedCount={
                    this.state.jobDetails.regretted_count
                      ? parseInt(this.state.jobDetails.regretted_count) < 100
                        ? parseInt(this.state.jobDetails.regretted_count) + 100
                        : parseInt(this.state.jobDetails.regretted_count)
                      : 100
                  }
                  totalCount={
                    parseInt(this.state.jobDetails.sent_to_client) < 100
                      ? parseInt(this.state.jobDetails.sent_to_client) + 100
                      : parseInt(this.state.jobDetails.sent_to_client)
                  }
                />
              </div>
              <div class="col-md-4">
                <CircleProgressBar
                  className={"unsort-candidates"}
                  title={"Unsorted Candidates"}
                  strokeDashArray={this.state.jobDetails.unsortedPercent}
                  stroke={"#609eda"}
                  strokeColor={"url(#blue)"}
                  linearGradientColor={"blue"}
                  stopColorStart={"#14385b"}
                  stopColorEnd={"#609eda"}
                  processedCount={
                    this.state.jobDetails.unsorted_count
                      ? parseInt(this.state.jobDetails.unsorted_count) < 100
                        ? parseInt(this.state.jobDetails.unsorted_count) + 100
                        : parseInt(this.state.jobDetails.unsorted_count)
                      : 100
                  }
                  totalCount={
                    parseInt(this.state.jobDetails.sent_to_client) < 100
                      ? parseInt(this.state.jobDetails.sent_to_client) + 100
                      : parseInt(this.state.jobDetails.sent_to_client)
                  }
                />
              </div>
            </div>
          </div>
        </MediaQuery>
        {/* Recruiter reports circle progreebar second main row Desktop view ends */}
        {/* Recruiter reports circle progreebar second main row ends */}
        <MediaQuery query="(max-device-width: 767px)">
          {/* Recruiter reports Multi-vertical ProgressBar third main row first section starts */}
          <div className="top-progressed-jobs card-item">
            <div className="progressed-categories">
              <h6>Top Progressed Jobs</h6>
              <span className="greenSquare">Progress</span>
              <span className="redSquare">Regret</span>
              <span className="blueSquare">Unsorted</span>
            </div>
            {this.state.topProgressedJobs.length > 0
              ? this.state.topProgressedJobs.map((job, index) => (
                  <MultiVerticalProgressBar
                    jobTitle={job.job_name}
                    greenPercentage={job.progressed_count}
                    redPercentage={job.regretted_count}
                    bluePercentage={job.unsorted_count}
                  />
                ))
              : null}
            {Array(4 - this.state.topProgressedJobs.length)
              .fill(null)
              .map(() => (
                <MultiVerticalProgressBar greenPercentage={null} />
              ))}
          </div>
        </MediaQuery>
        <MediaQuery query="(min-device-width: 768px)">
          <div className="card-item top-progressed-jobs">
            <div className="progressed-categories">
              <h6>Top Progressed Jobs</h6>
              <span className="greenSquare">Progress</span>
              <span className="redSquare">Regret</span>
              <span className="blueSquare">Unsorted</span>
            </div>
            <div className="top-progress-wrapper">
              {this.state.topProgressedJobs.length > 0
                ? this.state.topProgressedJobs.map((job, index) => (
                    <div class="col-md-4">
                      <MultiVerticalProgressBar
                        jobTitle={job.job_name}
                        greenPercentage={job.progressed_count}
                        redPercentage={job.regretted_count}
                        bluePercentage={job.unsorted_count}
                      />
                    </div>
                  ))
                : null}
              {Array(4 - this.state.topProgressedJobs.length)
                .fill(null)
                .map(() => (
                  <div class="col-md-4">
                    <MultiVerticalProgressBar greenPercentage={null} />
                  </div>
                ))}
            </div>
          </div>
        </MediaQuery>
        {/* Recruiter reports Multi-vertical ProgressBar third main row first section ends */}
      </div>
    );
  }
}

/**
 * @desc connecting to redux store
 * @param state
 * @return redux state
 */
const mapStateToProps = state => {
  return {
    jobs: state.talentPool.jobList,
    jobTitleId: state.talentPool.jobTitleId,
    clientDetails: state.clientProfile.clientDetails
  };
};

/**
 * @desc connecting to redux actions
 * @param dispatch
 * @return redux actions
 */

const mapDispatchToProps = dispatch => {
  return {
    onSetJobTitles: (jobTitleId, jobTitle, jobBHID, companyType) =>
      dispatch(actions.setJobTitle(jobTitleId, jobTitle, jobBHID, companyType))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(ClientReport, axios));



// WEBPACK FOOTER //
// ./src/container/Client/ClientReport/ClientReport.js